import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Card, CardContent } from "@/components/ui/card";
import { AlertTriangle, ArrowLeft } from "lucide-react";

export default function RefundPolicyPage() {
  return (
    <div className="min-h-screen bg-[#fbfdfc]">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
          <Logo size={42} />
          <Link
            to="/apply"
            className="text-sm text-brand-700 hover:underline inline-flex items-center gap-1"
            data-testid="back-to-apply"
          >
            <ArrowLeft size={14} /> Back to application
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-8 md:py-12">
        <Card className="tj-card">
          <CardContent className="p-6 md:p-8">
            <div className="flex items-center gap-3 mb-4">
              <div className="h-10 w-10 rounded-full bg-rose-100 text-rose-700 grid place-items-center">
                <AlertTriangle size={20} />
              </div>
              <div>
                <h1 className="font-heading text-2xl font-semibold text-ink-900">
                  Refund &amp; Cancellation Policy
                </h1>
                <p className="text-xs text-ink-600 mt-0.5">
                  Tulsi Jobs Placement Consultant
                </p>
              </div>
            </div>

            <div className="rounded-xl border border-rose-200 bg-rose-50 p-4 mb-6">
              <p className="text-sm text-rose-900">
                <strong>
                  All payments made on this platform are final and non-refundable
                  under any circumstances.
                </strong>{" "}
                Please read the points below carefully before paying.
              </p>
            </div>

            <ol className="space-y-4 text-sm text-ink-800 leading-relaxed list-decimal pl-5">
              <li>
                <strong>Service paid for.</strong> The ₹200 charge is for the
                instant generation and digital delivery of your resume PDF
                document. Once payment is captured, the PDF is generated and
                delivered to the candidate&apos;s browser for download, completing
                the service.
              </li>
              <li>
                <strong>Non-refundable.</strong> Because the service is digital
                and is rendered immediately upon successful payment, the
                transaction is non-reversible. No refunds will be issued for
                any reason including but not limited to: change of mind, typing
                errors in the form, dissatisfaction with the resume layout,
                inability to find a job, accidental double payment by the same
                user, or non-receipt of a job offer.
              </li>
              <li>
                <strong>No guarantee of placement.</strong> Paying for the
                resume download does not guarantee shortlisting, interview
                calls, employment, or any specific outcome from Tulsi Jobs
                Placement Consultant or any of its associated employers.
              </li>
              <li>
                <strong>Re-editing is free.</strong> If you need to correct
                details on your resume, you may freely edit your information on
                the resume builder page using your private link. The updated
                PDF can be downloaded again at no additional charge for the
                same payment.
              </li>
              <li>
                <strong>Failed/incomplete payments.</strong> If your UPI payment
                fails or is not completed, no charge is captured on our side.
                Any provisional hold placed by your bank is automatically
                released within 5–7 business days as per bank policy — this is
                outside Tulsi Jobs&apos; control.
              </li>
              <li>
                <strong>Disputes.</strong> Any disputes regarding payment must
                be raised in writing within 24 hours of the transaction to{" "}
                <a
                  href="mailto:support@tulsijobs.com"
                  className="text-brand-700 hover:underline"
                >
                  support@tulsijobs.com
                </a>{" "}
                with the UPI UTR / transaction reference number and screenshot.
                After investigation, the decision of Tulsi Jobs Placement
                Consultant shall be final and binding.
              </li>
              <li>
                <strong>Free submission option.</strong> If you do not wish to
                pay, you can still submit your resume to our recruiters at no
                cost using the &quot;Submit free to recruiter&quot; option on
                the resume builder page.
              </li>
            </ol>

            <p className="text-xs text-ink-600 mt-8">
              By proceeding with the payment of ₹200, you acknowledge that you
              have read, understood, and agreed to this Refund &amp;
              Cancellation Policy in full.
            </p>
          </CardContent>
        </Card>
      </main>
      <footer className="text-center text-xs text-ink-600 py-8">
        © {new Date().getFullYear()} Tulsi Jobs Placement Consultant
      </footer>
    </div>
  );
}
